export default "__VITE_ASSET__BjUAFwyS__"